var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 380 197",
    style: {
      enableBackground: "new 0 0 380 197"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECECEC;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#ACACAC;}\n\t.st3{fill:#898989;}\n\t.st4{fill:#DADADA;}\n\t.st5{fill:#F1F1F1;}\n\t.st6{fill:#CCCCCC;}\n\t.st7{fill:#565656;}\n\t.st8{fill:#E7E7E7;}\n\t.st9{fill:#484848;}\n\t.st10{fill:#838383;}\n\t.st11{fill:#373737;}\n\t.st12{fill:#5E5E5E;}\n\t.st13{fill:#E1E1E1;}\n\t.st14{fill:#C6C6C6;}\n\t.st15{fill:#A5A5A5;}\n\t.st16{fill:none;stroke:#5E5E5E;stroke-width:2.714;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st17{fill:#F8F8F8;}\n\t.st18{fill:#B0B0B0;}\n\t.st19{fill:#262626;}\n\t.st20{fill:#151515;}\n\t.st21{fill:#0F0F0F;}\n\t.st22{fill:none;stroke:#151515;stroke-width:2.5953;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st23{fill:#8A8A8A;}\n\t.st24{fill:#BCBCBC;}\n\t.st25{fill:#626262;}\n\t.st26{fill:#404040;}\n\t.st27{fill:#1D1D1D;}\n\t.st28{fill:#C3C3C3;}\n\t.st29{fill:#727272;}\n\t.st30{fill:#2C2C2C;}\n\t.st31{fill:#B4B4B4;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.4,49.3c-8.2,0-16.1,1.1-23.6,3.3c-19.3-24.9-49.5-40.9-83.5-40.9c-50.3,0-92.4,35.2-103,82.3 c-1.4-0.3-2.8-0.4-4.3-0.4c-11.5,0-20.8,9.3-20.8,20.8c0,1.4,0.1,2.8,0.4,4.2c-22.8,5.9-39.7,26.6-39.7,51.3 c0,9.9,2.7,19.2,7.5,27.2h328.8c15.4-15.7,25-37.2,25-60.9C379.1,88.1,340.3,49.3,292.4,49.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.3,66L259,41.8l-29.1,83.3l69.2,24.2L328.3,66z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M279.8,57.5l-17.5-6.1l-0.5,1.5l17.5,6.1L279.8,57.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M299.5,64.4L282,58.2l-0.5,1.5l17.5,6.1L299.5,64.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.2,71.3l-17.5-6.1l-0.5,1.5l17.5,6.1L319.2,71.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.8,60.4l-17.5-6.1l-0.5,1.5l17.5,6.1L278.8,60.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M298.4,67.3L281,61.2l-0.5,1.5l17.5,6.1L298.4,67.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M318.2,74.2l-17.5-6.1l-0.5,1.5l17.5,6.1L318.2,74.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.7,63.4l-17.5-6.1l-0.5,1.5l17.5,6.1L277.7,63.4z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.4,70.3l-17.5-6.1l-0.5,1.5l17.5,6.1L297.4,70.3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M317.1,77.2l-17.5-6.1l-0.5,1.5l17.5,6.1L317.1,77.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M276.7,66.4l-17.5-6.1l-0.5,1.5l17.5,6.1L276.7,66.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.4,73.3l-17.5-6.1l-0.5,1.5l17.5,6.1L296.4,73.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M316.1,80.2l-17.5-6.1l-0.5,1.5l17.5,6.1L316.1,80.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M275.6,69.3l-17.5-6.1l-0.5,1.5l17.5,6.1L275.6,69.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.3,76.2l-17.5-6.1l-0.5,1.5l17.5,6.1L295.3,76.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M315.1,83.1L297.6,77l-0.5,1.5l17.5,6.1L315.1,83.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M274.6,72.3l-17.5-6.1l-0.5,1.5l17.5,6.1L274.6,72.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294.3,79.2l-17.5-6.1l-0.5,1.5l17.5,6.1L294.3,79.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M314,86.1L296.6,80l-0.5,1.5l17.5,6.1L314,86.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.6,75.3l-17.5-6.1l-0.5,1.5l17.5,6.1L273.6,75.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293.2,82.2l-17.5-6.1l-0.5,1.5l17.5,6.1L293.2,82.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M313,89.1L295.5,83l-0.5,1.5l17.5,6.1L313,89.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M272.5,78.2l-17.5-6.1l-0.5,1.5l17.5,6.1L272.5,78.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.2,85.1L274.7,79l-0.5,1.5l17.5,6.1L292.2,85.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M311.9,92l-17.5-6.1l-0.5,1.5l17.5,6.1L311.9,92z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M271.5,81.2L254,75.1l-0.5,1.5l17.5,6.1L271.5,81.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.2,88.1L273.7,82l-0.5,1.5l17.5,6.1L291.2,88.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M310.9,95l-17.5-6.1l-0.5,1.5l17.5,6.1L310.9,95z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M270.5,84.1L253,78l-0.5,1.5l17.5,6.1L270.5,84.1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290.1,91l-17.5-6.1l-0.5,1.5l17.5,6.1L290.1,91z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M309.9,97.9l-17.5-6.1l-0.5,1.5l17.5,6.1L309.9,97.9z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M269.4,87.1L251.9,81l-0.5,1.5l17.5,6.1L269.4,87.1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.1,94l-17.5-6.1l-0.5,1.5l17.5,6.1L289.1,94z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.8,100.9l-17.5-6.1l-0.5,1.5l17.5,6.1L308.8,100.9z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M268.4,90.1L250.9,84l-0.5,1.5l17.5,6.1L268.4,90.1z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.1,97l-17.5-6.1l-0.5,1.5l17.5,6.1L288.1,97z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M307.8,103.9l-17.5-6.1l-0.5,1.5l17.5,6.1L307.8,103.9z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M267.3,93.1l-17.5-6.1l-0.5,1.5l17.5,6.1L267.3,93.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287,99.9l-17.5-6.1l-0.5,1.5l17.5,6.1L287,99.9z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M306.8,106.8l-17.5-6.1l-0.5,1.5l17.5,6.1L306.8,106.8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.3,96l-17.5-6.1l-0.5,1.5l17.5,6.1L266.3,96z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M286,102.9l-17.5-6.1l-0.5,1.5l17.5,6.1L286,102.9z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M305.7,109.8l-17.5-6.1l-0.5,1.5l17.5,6.1L305.7,109.8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M265.3,99l-17.5-6.1l-0.5,1.5l17.5,6.1L265.3,99z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.9,105.9l-17.5-6.1l-0.5,1.5l17.5,6.1L284.9,105.9z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M304.7,112.8l-17.5-6.1l-0.5,1.5l17.5,6.1L304.7,112.8z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M264.2,102l-17.5-6.1l-0.5,1.5l17.5,6.1L264.2,102z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.9,108.8l-17.5-6.1l-0.5,1.5l17.5,6.1L283.9,108.8z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303.6,115.8l-17.5-6.1l-0.5,1.5l17.5,6.1L303.6,115.8z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M263.2,104.9l-17.5-6.1l-0.5,1.5l17.5,6.1L263.2,104.9z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.9,111.8l-17.5-6.1l-0.5,1.5l17.5,6.1L282.9,111.8z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M302.6,118.7l-17.5-6.1l-0.5,1.5l17.5,6.1L302.6,118.7z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M262.2,107.9l-17.5-6.1l-0.5,1.5l17.5,6.1L262.2,107.9z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M281.8,114.8l-17.5-6.1l-0.5,1.5l17.5,6.1L281.8,114.8z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.6,121.7l-17.5-6.1l-0.5,1.5l17.5,6.1L301.6,121.7z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.1,110.9l-17.5-6.1l-0.5,1.5l17.5,6.1L261.1,110.9z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.8,117.8l-17.5-6.1l-0.5,1.5l17.5,6.1L280.8,117.8z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M300.5,124.7l-17.5-6.1l-0.5,1.5l17.5,6.1L300.5,124.7z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260.1,113.8l-17.5-6.1l-0.5,1.5l17.5,6.1L260.1,113.8z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M279.8,120.7l-17.5-6.1l-0.5,1.5l17.5,6.1L279.8,120.7z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M299.5,127.6l-17.5-6.1l-0.5,1.5l17.5,6.1L299.5,127.6z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M259,116.8l-17.5-6.1l-0.5,1.5l17.5,6.1L259,116.8z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.7,123.7l-17.5-6.1l-0.5,1.5l17.5,6.1L278.7,123.7z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M298.5,130.6l-17.5-6.1l-0.5,1.5l17.5,6.1L298.5,130.6z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M258,119.7l-17.5-6.1l-0.5,1.5l17.5,6.1L258,119.7z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.7,126.6l-17.5-6.1l-0.5,1.5l17.5,6.1L277.7,126.6z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.4,133.5l-17.5-6.1l-0.5,1.5l17.5,6.1L297.4,133.5z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M279.8,57.5l-17.5-6.1l-11.9,34.1l17.5,6.1L279.8,57.5z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.2,71.3l-17.5-6.1l-4.6,13.1l17.5,6.1L319.2,71.3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M305.7,109.9l-17.5-6.1l-4.6,13.1l17.5,6.1L305.7,109.9z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M275.4,44.7l-19.3-4.4l-3.3,14.4l19.3,4.4L275.4,44.7z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M268,77.6l-19.3-4.4l-3.3,14.4l19.3,4.4L268,77.6z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.2,43l-76.4-17.3L209,117.5l76.4,17.3L306.2,43z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M253.7,39.8l-19.3-4.4l-0.4,1.6l19.3,4.4L253.7,39.8z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M275.4,44.7l-19.3-4.4l-0.4,1.6l19.3,4.4L275.4,44.7z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M297.1,49.6l-19.3-4.4l-0.4,1.6l19.3,4.4L297.1,49.6z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M252.9,43.1l-19.3-4.4l-0.4,1.6l19.3,4.4L252.9,43.1z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M274.7,48l-19.3-4.4l-0.4,1.6l19.3,4.4L274.7,48z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M296.4,52.9l-19.3-4.4l-0.4,1.6l19.3,4.4L296.4,52.9z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M252.2,46.3L232.9,42l-0.4,1.6l19.3,4.4L252.2,46.3z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M273.9,51.3l-19.3-4.4l-0.4,1.6l19.3,4.4L273.9,51.3z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M295.7,56.2l-19.3-4.4l-0.4,1.6l19.3,4.4L295.7,56.2z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M251.5,49.6l-19.3-4.4l-0.4,1.6l19.3,4.4L251.5,49.6z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M273.2,54.5l-19.3-4.4l-0.4,1.6l19.3,4.4L273.2,54.5z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.9,59.4l-19.3-4.4l-0.4,1.6l19.3,4.4L294.9,59.4z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250.7,52.9l-19.3-4.4l-0.4,1.6l19.3,4.4L250.7,52.9z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M272.5,57.8l-19.3-4.4l-0.4,1.6l19.3,4.4L272.5,57.8z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.2,62.7l-19.3-4.4l-0.4,1.6l19.3,4.4L294.2,62.7z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250,56.2l-19.3-4.4l-0.4,1.6l19.3,4.4L250,56.2z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M271.7,61.1l-19.3-4.4l-0.4,1.6l19.3,4.4L271.7,61.1z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M293.4,66l-19.3-4.4l-0.4,1.6l19.3,4.4L293.4,66z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M249.2,59.4L230,55.1l-0.4,1.6l19.3,4.4L249.2,59.4z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M271,64.3L251.7,60l-0.4,1.6l19.3,4.4L271,64.3z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M292.7,69.3l-19.3-4.4l-0.4,1.6l19.3,4.4L292.7,69.3z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248.5,62.7l-19.3-4.4l-0.4,1.6l19.3,4.4L248.5,62.7z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M270.2,67.6L251,63.2l-0.4,1.6l19.3,4.4L270.2,67.6z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M292,72.5l-19.3-4.4l-0.4,1.6l19.3,4.4L292,72.5z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M247.8,65.9l-19.3-4.4l-0.4,1.6l19.3,4.4L247.8,65.9z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M269.5,70.9l-19.3-4.4l-0.4,1.6l19.3,4.4L269.5,70.9z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M291.2,75.8l-19.3-4.4l-0.4,1.6l19.3,4.4L291.2,75.8z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M247,69.3l-19.3-4.4l-0.4,1.6l19.3,4.4L247,69.3z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M268.7,74.2l-19.3-4.4l-0.4,1.6l19.3,4.4L268.7,74.2z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M290.5,79.1l-19.3-4.4l-0.4,1.6l19.3,4.4L290.5,79.1z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M246.3,72.5L227,68.1l-0.4,1.6l19.3,4.4L246.3,72.5z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M268,77.4l-19.3-4.4l-0.4,1.6l19.3,4.4L268,77.4z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289.7,82.4L270.5,78l-0.4,1.6l19.3,4.4L289.7,82.4z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M245.5,75.8l-19.3-4.4l-0.4,1.6l19.3,4.4L245.5,75.8z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M267.3,80.7L248,76.3l-0.4,1.6l19.3,4.4L267.3,80.7z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289,85.6l-19.3-4.4l-0.4,1.6l19.3,4.4L289,85.6z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M244.8,79l-19.3-4.4l-0.4,1.6l19.3,4.4L244.8,79z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M266.5,84l-19.3-4.4l-0.4,1.6l19.3,4.4L266.5,84z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M288.3,88.9L269,84.5l-0.4,1.6l19.3,4.4L288.3,88.9z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M244,82.3L224.8,78l-0.4,1.6l19.3,4.4L244,82.3z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265.8,87.3l-19.3-4.4l-0.4,1.6l19.3,4.4L265.8,87.3z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M287.5,92.2l-19.3-4.4l-0.4,1.6l19.3,4.4L287.5,92.2z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M243.3,85.6L224,81.2l-0.4,1.6l19.3,4.4L243.3,85.6z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265,90.5l-19.3-4.4l-0.4,1.6l19.3,4.4L265,90.5z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M286.8,95.4l-19.3-4.4l-0.4,1.6l19.3,4.4L286.8,95.4z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M242.6,88.9l-19.3-4.4l-0.4,1.6l19.3,4.4L242.6,88.9z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M264.3,93.8L245,89.4l-0.4,1.6l19.3,4.4L264.3,93.8z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M286,98.7l-19.3-4.4l-0.4,1.6l19.3,4.4L286,98.7z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M241.8,92.1l-19.3-4.4l-0.4,1.6l19.3,4.4L241.8,92.1z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M263.6,97l-19.3-4.4l-0.4,1.6l19.3,4.4L263.6,97z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285.3,102L266,97.6l-0.4,1.6l19.3,4.4L285.3,102z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M241.1,95.4l-19.3-4.4l-0.4,1.6l19.3,4.4L241.1,95.4z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M262.8,100.4L243.5,96l-0.4,1.6l19.3,4.4L262.8,100.4z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M284.5,105.3l-19.3-4.4l-0.4,1.6l19.3,4.4L284.5,105.3z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.3,98.7l-19.3-4.4l-0.4,1.6l19.3,4.4L240.3,98.7z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M262.1,103.6l-19.3-4.4l-0.4,1.6l19.3,4.4L262.1,103.6z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M283.8,108.5l-19.3-4.4l-0.4,1.6l19.3,4.4L283.8,108.5z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M239.6,102l-19.3-4.4l-0.4,1.6l19.3,4.4L239.6,102z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M261.3,106.9l-19.3-4.4l-0.4,1.6l19.3,4.4L261.3,106.9z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M283.1,111.8l-19.3-4.4l-0.4,1.6l19.3,4.4L283.1,111.8z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M238.9,105.2l-19.3-4.4l-0.4,1.6l19.3,4.4L238.9,105.2z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M260.6,110.1l-19.3-4.4l-0.4,1.6l19.3,4.4L260.6,110.1z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M282.3,115.1l-19.3-4.4l-0.4,1.6l19.3,4.4L282.3,115.1z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M238.1,108.5l-19.3-4.4l-0.4,1.6l19.3,4.4L238.1,108.5z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M259.9,113.4l-19.3-4.4l-0.4,1.6l19.3,4.4L259.9,113.4z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M281.6,118.4l-19.3-4.4l-0.4,1.6l19.3,4.4L281.6,118.4z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M170.8,138.4c-20.5,0-37.9,13.8-43.2,32.6h86.5C208.7,152.2,191.4,138.4,170.8,138.4z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M288.8,138.4c-20.5,0-37.9,13.8-43.2,32.6h86.5C326.7,152.2,309.4,138.4,288.8,138.4z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M232.6,124.5c-29.4,0-54.1,19.7-61.8,46.6h123.5C286.7,144.2,262,124.5,232.6,124.5z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M184.3,152.7l-0.9,11.9h31.3l-0.9-11.9H184.3z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.3,146.2h-28.5l-0.5,6.5h29.5L213.3,146.2z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.6,168.7h-47.1v-2.4c0-1.5,1.2-2.7,2.7-2.7h41.7c1.5,0,2.7,1.2,2.7,2.7V168.7z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M268.4,48H129.7c-2.3,0-4.2,1.9-4.2,4.2v83.2h87.2h59.8V75.6V52.2C272.6,49.9,270.7,48,268.4,48z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.7,135.4h-87.2v10c0,2.3,1.9,4.2,4.2,4.2h68.7h69.9c2.3,0,4.2-1.9,4.2-4.2v-10H212.7z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M198.6,53.1h-16.5h-51.4v51.4v25h67.9h67.9V53.1H198.6z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.1,94.1l-82.3,6.3l4.4,57.7l82.3-6.3L154.1,94.1z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M153.1,147.2l-3.7-47.8L77.1,105l3.7,47.8L153.1,147.2z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M115,138.3c7.4,0,13.5-6,13.5-13.5c0-7.4-6-13.5-13.5-13.5c-7.4,0-13.5,6-13.5,13.5 C101.6,132.2,107.6,138.3,115,138.3z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M153.1,147.2l-1.6-20.2l-72.3,5.6l1.6,20.2L153.1,147.2z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.3,121.1c-0.2,0.1-0.5,0.1-0.7,0.2c-0.2,0-0.5-0.1-0.7-0.1c-0.5-0.1-1.1-0.1-1.7,0c-1.2,0.1-2.3,0.4-3.2,0.9 c0.3-1.5,1.5-2.6,3.1-2.8c0.9-0.1,1.8,0.2,2.4,0.8C91.8,120.3,92.1,120.7,92.3,121.1z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.3,121.2c-1-0.3-2.1-0.5-3.3-0.4c-0.6,0-1.1,0.1-1.6,0.3c-0.2,0.1-0.5,0.1-0.7,0.2c-0.2,0-0.5-0.1-0.7-0.1 c0.1-0.4,0.3-0.8,0.6-1.1c0.5-0.7,1.4-1.1,2.3-1.2C95.4,118.7,96.8,119.7,97.3,121.2z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.2,116.1c-0.2,0-0.5,0-0.7,0c-0.2-0.1-0.4-0.2-0.7-0.4c-0.5-0.2-1-0.4-1.5-0.6c-1.2-0.3-2.3-0.4-3.3-0.3 c0.8-1.3,2.3-2,3.8-1.5c0.9,0.3,1.6,0.9,2,1.6C103,115.2,103.1,115.7,103.2,116.1z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.8,117.9c-0.8-0.7-1.8-1.2-3-1.5c-0.5-0.2-1.1-0.3-1.6-0.3c-0.2,0-0.5,0-0.7,0c-0.2-0.1-0.4-0.2-0.7-0.4 c0.3-0.3,0.6-0.6,1-0.8c0.8-0.4,1.7-0.5,2.6-0.3C106.9,115,107.8,116.4,107.8,117.9z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M136.2,134.2c-0.1-0.8-0.7-1.3-1.5-1.3l-4,0.3c-0.5,0-0.9-0.3-1-0.8c0-0.5,0.3-0.9,0.8-1l1.1-0.1 c0.8-0.1,1.3-0.7,1.3-1.5c-0.1-0.8-0.7-1.3-1.5-1.3L99.3,131c-0.8,0.1-1.3,0.7-1.3,1.5c0.1,0.8,0.7,1.3,1.5,1.3l1.1-0.1 c0.5,0,0.9,0.3,1,0.8c0,0.5-0.3,0.9-0.8,1l-8.2,0.6c-0.8,0.1-1.3,0.7-1.3,1.5c0.1,0.8,0.7,1.3,1.5,1.3l12.7-1c0.6,0,1.1,0.4,1.1,1 c0,0.6-0.4,1.1-1,1.1l-5.6,0.4c-0.8,0.1-1.3,0.7-1.3,1.5c0.1,0.8,0.7,1.3,1.5,1.3l32.3-2.5c0.8-0.1,1.3-0.7,1.3-1.5 c-0.1-0.8-0.7-1.3-1.5-1.3l-5.6,0.4c-0.6,0-1.1-0.4-1.1-1c0-0.6,0.4-1.1,1-1.1l8.4-0.7C135.7,135.6,136.3,134.9,136.2,134.2z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M119.4,146l-14.8,1.1c-0.8,0.1-1.4-0.5-1.5-1.3c-0.1-0.8,0.5-1.4,1.3-1.5l14.8-1.1c0.8-0.1,1.4,0.5,1.5,1.3 C120.8,145.3,120.2,145.9,119.4,146z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M131.5,145.1l-6.5,0.5c-0.8,0.1-1.4-0.5-1.5-1.3c-0.1-0.8,0.5-1.4,1.3-1.5l6.5-0.5c0.8-0.1,1.4,0.5,1.5,1.3 C132.9,144.3,132.3,145,131.5,145.1z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M115.6,137.1l-5.2,0.4c-0.6,0-1.2-0.4-1.2-1c0-0.6,0.4-1.2,1-1.2l5.2-0.4c0.6,0,1.2,0.4,1.2,1 C116.7,136.5,116.2,137.1,115.6,137.1z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M305.4,51.2c-4.4,0-8.1,3-9.3,7h18.6C313.6,54.2,309.8,51.2,305.4,51.2z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M330.8,51.2c-4.4,0-8.1,3-9.3,7h18.6C338.9,54.2,335.2,51.2,330.8,51.2z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M318.7,48.3c-6.3,0-11.6,4.2-13.3,10H332C330.4,52.5,325,48.3,318.7,48.3z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M28.7,61.3c-13.3,0-24.5,8.9-28,21.1h56C53.3,70.2,42,61.3,28.7,61.3z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M105.1,61.3c-13.3,0-24.5,8.9-28,21.1h56C129.6,70.2,118.5,61.3,105.1,61.3z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M68.7,52.2c-19,0-35.1,12.7-40,30.1h80C103.8,65,87.7,52.2,68.7,52.2z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M294.9,181.9H103.1c-3.5,0-6.4-2.9-6.4-6.4c0-3.5,2.9-6.4,6.4-6.4h191.8c3.5,0,6.4,2.9,6.4,6.4 C301.3,179,298.5,181.9,294.9,181.9z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M250.4,9.4c-6.1,0-11.2,4.1-12.8,9.6h25.5C261.5,13.4,256.4,9.4,250.4,9.4z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M285.1,9.4c-6.1,0-11.2,4.1-12.8,9.6h25.5C296.3,13.4,291.2,9.4,285.1,9.4z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M268.6,5.3c-8.7,0-16,5.8-18.2,13.7h36.4C284.5,11.1,277.2,5.3,268.6,5.3z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M79.6,166c-6.9,0-12.7,4.6-14.5,11h29C92.3,170.6,86.5,166,79.6,166z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M119.2,166c-6.9,0-12.7,4.6-14.5,11h29C131.9,170.6,126.1,166,119.2,166z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M100.4,161.3c-9.9,0-18.2,6.6-20.7,15.6h41.4C118.5,167.9,110.2,161.3,100.4,161.3z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M259.6,168.2c-10.2,0-18.8,6.8-21.4,16.2h42.9C278.4,175,269.8,168.2,259.6,168.2z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M290.2,161.3c-14.6,0-26.8,9.8-30.6,23.1h61.2C317,171,304.7,161.3,290.2,161.3z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,50.9l-82.3-5.6l-4,57.7l82.3,5.6L169.6,50.9z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92,50.6l-3.3,47.8l72.4,5l3.3-47.8L92,50.6z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M161.1,103.4l0.9-13.1l-72.4-5l-0.9,13.1L161.1,103.4z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M161.6,95.2l0.3-5l-72.4-5l-0.3,5L161.6,95.2z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M130.7,89.2L113.6,88l7.4-12.8l2.4-4.1l1.5,3.7L130.7,89.2z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M150.5,90.6l-31-2.1l14-24.2l3.7-6.5l3.3,8.1L150.5,90.6z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M133,69.8l-10.8,18.8l18.9,1.3L133,69.8z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M162.2,85.9l-0.4,5.4l-25.4-1.8l16-27.8L162.2,85.9z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.5,65.8l-0.9,2.2l-1.5-2.4l-1.1,1.6l-1.6-4l-1.5,2.5l-0.5-1.5l3.7-6.5L140.5,65.8z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.9,74.8l-0.8-0.5l-1.3,2.4l-0.3-2.5l-1.5,1l2.4-4.1L124.9,74.8z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M108.7,87.7l0.6-9.7"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M97,86.9l1.2-18.5"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M110.3,84.6c2.7-0.6,4.4-3.2,3.8-5.9c-0.6-2.7-3.2-4.4-5.9-3.8c-2.7,0.6-4.4,3.2-3.8,5.9 S107.6,85.2,110.3,84.6z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M112.6,76.1c0.8-1.6,0.1-3.6-1.6-4.4c-1.6-0.8-3.6-0.1-4.4,1.6c-0.8,1.6-0.1,3.6,1.6,4.4 C109.8,78.4,111.8,77.7,112.6,76.1z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M101.1,77.7c2.1-1.8,2.3-5,0.5-7c-1.8-2.1-5-2.3-7-0.5c-2.1,1.8-2.3,5-0.5,7C95.9,79.2,99.1,79.5,101.1,77.7z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M92.6,78.5c0.2-2.7,2.6-4.8,5.3-4.6c2.7,0.2,4.8,2.6,4.6,5.3c-0.2,2.7-2.6,4.8-5.3,4.6 C94.4,83.6,92.4,81.2,92.6,78.5z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M94.9,68.6c0.1-1.8,1.7-3.2,3.5-3.1c1.8,0.1,3.2,1.7,3.1,3.5c-0.1,1.8-1.7,3.2-3.5,3.1 C96.1,72,94.8,70.4,94.9,68.6z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M112.7,59.7c-1.9-0.1-3.7,1.1-4.3,2.8l8.1,0.6C116.1,61.2,114.6,59.8,112.7,59.7z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123.8,60.4c-1.9-0.1-3.7,1.1-4.3,2.8l8.1,0.6C127.2,61.9,125.7,60.5,123.8,60.4z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M118.6,58.7c-2.7-0.2-5.2,1.5-6.1,4l11.6,0.8C123.5,60.9,121.3,58.9,118.6,58.7z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M116.8,18.8c0,0-0.8-4.1-1.7-4.6c-0.9-0.5-0.7,3.5,1,5.4L116.8,18.8z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M116.9,17.8c-0.6,0.3-1.2,0.6-1.7,0.8c4.7,9.8,11.4,14.9,19.4,5.2c1.2-1.5,0.7-1.5-0.2-2.3c-0.1-0.3,0-0.2,0,0 c-0.9-0.8-1.4-1.1-2.4,0.4C125.3,31.4,121.8,24.7,116.9,17.8z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M117.7,68.7c0,0,0.1,0,0.1-0.1c0.4-0.2,0.5-0.7,0.2-1.1l-3-4.7c-0.2-0.4-0.7-0.5-1.1-0.2 c-0.4,0.2-0.5,0.7-0.2,1.1l2.9,4.7C117,68.7,117.4,68.8,117.7,68.7z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M117.8,66.8c0,0,1.6,1.2,1.3,1.6c-0.3,0.4-5.6,4.8-5.8,4.6c-0.8-0.8,3-5.1,3.5-5.3 C117.2,67.4,117.5,66.6,117.8,66.8z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M87.2,46.8c0,0,0,0.1,0,0.2c0.1,0.4,0.5,0.7,0.9,0.6l5.4-1.2c0.4-0.1,0.7-0.5,0.6-0.9 c-0.1-0.4-0.5-0.7-0.9-0.6L87.8,46C87.5,46.1,87.2,46.4,87.2,46.8z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M90.4,44.7c0,0.8,0.1,1.6,0.3,2.5c11.8-2.5,27.3-4.6,39.4-0.3c2.2,0.8,4.6-0.2,5.5-2.4c0.3-0.7,0.6-1.4,1-2.1 C125.7,37.9,101.6,42.5,90.4,44.7z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M114.4,66c0.7-0.6,1.4-1.3,2.1-1.9c-12.4-16.2,2.3-17.1,15.3-15.9c2,0.2,4-1.6,4.1-3.9c0-0.7,0.2-1.4,0.1-2.1 C119.9,43.1,100.1,45.5,114.4,66z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M88.3,47.7c0,0-2,0.5-2,0c-0.1-0.5-0.4-7.4-0.1-7.4c1.1-0.2,2.2,5.5,2.1,6C88.1,46.9,88.5,47.7,88.3,47.7z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M136.9,44c-1.1-0.3-2.7-0.5-5.4-0.3c-1.8,0.2-3.2,0.4-4.3,0.7c3.4-10.7,3.5-15.8,2.7-18.5 c-0.4-1.4,0-2.9,1-3.9l0.4-0.4c1.8-1.8,5-1.1,5.8,1.3c0.3,0.8,0.5,1.8,0.7,2.8C138.8,31,138.8,36.8,136.9,44z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M134.2,16.8c-0.6,2.3-2.7,3.7-4.1,3.3c-1.4-0.4-1.6-2.4-1-4.6c0.6-2.3,2-3.1,3.4-2.8 C134,13.1,134.8,14.6,134.2,16.8z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M135,17.9c-0.1,0.5-0.8,1.1-1.2,1c-0.4-0.1-0.3-0.5-0.2-1.1c0.1-0.5,0.6-0.9,1-0.9 C134.9,17.1,135.2,17.4,135,17.9z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M134.9,15.5c0,0-0.1-1.6-1.1-2.4c-1-0.8-3.2-1.3-4.2,0.6c0,0-0.6,1.4,1.2,2c1.8,0.6,1.6-0.5,2.3,0.6 s1.6,0.5,1.8,0.8L134.9,15.5z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M133.9,17l-2.5,0.1c0,0.3,0.2,3.5,0.5,4.7c0.2,0.4,0.8,0.5,1.4,0.2c0.6-0.2,1-0.6,0.9-1 C134,20.3,133.9,18.2,133.9,17z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M133.3,17.9c-0.5-0.2-0.7,0.2-1.4,0.9c-0.7,0.7-2.2,1.1-2.9-0.8c-0.5-1.2-0.5,1-0.5,1c0.2,1,0.7,1.6,1.5,1.8 c1.1,0.3,2.6-0.3,3.6-1.5C133.7,18.8,133.6,18.1,133.3,17.9z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M128.9,18c0,0,0,0,0.1,0c0.5,0.1,2.7,0.5,3.1,1.2c0.5,0.8-1.1,0-1.7-0.4c-0.5-0.4-1-0.2-1.4-0.2 C128.6,18.6,128.3,18.2,128.9,18z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M118.6,27.9c0,0-2.3-3.5-3.4-3.6c-1.1-0.1,0.8,3.5,3,4.6L118.6,27.9z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M118.3,27c-0.4,0.5-0.9,1-1.3,1.4c8.2,7.2,16.3,9.3,19.9-2.9c0.6-1.8,0-1.7-1.1-2c-0.2-0.3-0.1-0.2,0,0 c-1.1-0.4-1.8-0.5-2.1,1.3C131.3,36.1,125.5,31.3,118.3,27z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M117.5,2.9l-15.2,2l2.9,21.8l15.2-2L117.5,2.9z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M115.7,5.6l-10.9,1.4l0.1,0.7l10.9-1.4L115.7,5.6z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M115.9,7.4l-10.9,1.4l0.1,0.7L116,8.1L115.9,7.4z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M116.2,9.1l-10.9,1.4l0.1,0.7l10.9-1.4L116.2,9.1z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M116.4,10.9l-10.9,1.4l0.1,0.7l10.9-1.4L116.4,10.9z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M116.6,12.6l-10.9,1.4l0.1,0.7l10.9-1.4L116.6,12.6z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M116.9,14.3L106,15.8l0.1,0.7l10.9-1.4L116.9,14.3z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M117.1,16.1l-10.9,1.4l0.1,0.7l10.9-1.4L117.1,16.1z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M117.3,17.8l-10.9,1.4l0.1,0.7l10.9-1.4L117.3,17.8z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M117.6,19.6L106.7,21l0.1,0.7l10.9-1.4L117.6,19.6z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M248.1,98.6c-0.2-0.2-0.5-0.2-0.8,0c-0.2,0.1-0.4,0.4-0.4,0.7v13.4c-0.8-0.2-1.8-0.1-2.8,0.5 c-1.5,0.9-2.3,2.5-1.6,3.7c0.7,1.1,2.4,1.3,4,0.4c1.3-0.7,2-2,1.9-3c0-0.1,0-0.1,0-0.2v-13.3c1.4,1.3,3.5,3.6,2.3,5.5 c-0.2,0.3-0.1,0.8,0.2,1c0.3,0.2,0.8,0.1,1-0.2C254.5,103.1,248.3,98.8,248.1,98.6z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M293,156.8C293,156.8,293,156.8,293,156.8c0.3,0.3,0.5,0.5,0.7,0.7c0.1,0.1,0.1,0.1,0.2,0.2 c0.2,0.2,0.4,0.4,0.7,0.7c0,0,0.1,0.1,0.1,0.1c0.2,0.2,0.4,0.4,0.7,0.7c0.2,0.2,0.5,0.5,0.8,0.8l0,0c0.5,0.5,0.4,1.2,0.9,1.6 c0.6-0.8,1.8-2.1,2.5-2.8c1.5-1.3,3-2.3,4.6-3.3c0.3-0.2,0.6-0.4,0.9-0.6c0.2-0.1,0.3-0.2,0.5-0.3c7-4.3,14.6-5.3,22.7-9.9 c0.1-0.1,0.3-0.1,0.4-0.1c-0.3-0.5-0.6-1-0.9-1.5c-0.1,0.1-0.2,0-0.4,0.1c-11.2,7-13.3,3.1-23.9,7.4c-1,0.4-1.4,0.5-2.3,0.9 c-2.1,0.8-4.1,1.6-5.8,3c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1,0-0.7,0.6-1,0.9c-0.3,0.3-0.7,0.7-1,1.1C293.1,156.7,293,156.8,293,156.8z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M328.4,144.9c0,0,1.9-0.4,1.8-0.8c-0.1-0.4-2.7-6.6-3-6.5c-1,0.3,0.3,5.6,0.7,6.1 C328.2,144.1,328.1,145,328.4,144.9z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M290.9,139c6.6,8.5,10.7,5.5,19.1,2.2c0,0,0,0,0,0c0.2-0.1,0.3-0.2,0.5-0.3c-0.2-0.3-0.6-0.4-0.8-0.8 c-8.6,1.8-10.1,5.8-16.3-2.7c-0.9-1.3-1-1-2.4-0.8C290.7,137.7,289.9,137.6,290.9,139z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.8,140.3l0.3,0.9c0,0,0,0,0,0c0.2-0.1,0.3-0.2,0.5-0.3c1.9-1.4,3.1-4.3,2.2-4.1c-0.9,0.1-2.6,2.7-3,3.4 C309.8,140.2,309.8,140.3,309.8,140.3z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M291.4,156.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.2c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.3 c0,0.1,0,0.4,0.1,0.6c0,0.1,0,0.3,0.1,0.4c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0.1,0.3c0,0.1,0,0.2,0.1,0.3c0.1,0.4,0.2,0.8,0.4,1.2 c0,0.1,0,0,0,0.1c0,0.1,0-0.3,0,0.1c0.1,0.3,0.6,1.2,1,1.6c0.4,0.4,1,0.7,1.6,0.9c1.9,0.5,4.3,0.1,6,0.9c2.5,1.1,4.4,1.5,5.9,4.1 c4.2,7.7-0.3,12.3-6.7,16.8c-0.1,0.1-0.2,0.1-0.3,0.2c0.3,0.5,0.6,1,1,1.4c0.1-0.1,0.2-0.1,0.2-0.2c7.4-5.7,12.2-10.9,8.7-20.6 c-0.4-1.2-1.5-2.3-1.5-2.3c-1.6-1.8-3.5-3.1-5.6-4.2c-0.5-0.3-1.2-0.5-1.8-0.8c-0.3-0.1-0.7-0.2-0.9-0.3c-0.1,0,0,0,0,0 c-0.4-0.1-0.8-0.2-1.2-0.3c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0-0.5-0.1-0.7-0.1 c-0.7-0.1-1.3-0.2-1.9-0.2c-0.5-0.1-0.9-0.1-1.4-0.1c-0.5,0-1-0.1-1.4-0.1C291.5,156.1,291.5,156.1,291.4,156.1z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M300.9,183.8c0,0-2,0.1-1.9,0.6c0.1,0.4,1.9,6.8,2.2,6.8c1-0.2,0.3-5.7,0-6.1 C301,184.6,301.2,183.8,300.9,183.8z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M291.6,159.6c1-0.4,1.8-2.5,4.3-2.7c1.8-0.1,2.3,0.5,3.4,0.7c-4.9-9.4-5.1-14.9-4.8-17.6 c0.1-1.4-0.4-2.7-1.6-3.5l-0.4-0.3c-2-1.4-4.9-0.2-5.2,2.2c-0.1,0.8-0.2,1.8-0.2,2.8C287,146.1,288.6,153.1,291.6,159.6z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.8,159c0,0-2.3,3.3-2,4.3c0.3,1,2.8-2,3-4.4L281.8,159z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M292.2,135.9c0,0,1.2,2.4,1.2,4.9c0,2.2,0.3,7.1,1.3,7.7l1.2-0.6c0,0-0.9-3.8-1.2-5.9 c-0.3-2.2,0.8-2.5-0.6-5.2C292.7,134.2,292.2,135.9,292.2,135.9z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.2,132.2c1.1,1.9,3.4,2.7,4.5,2c1.2-0.7,0.8-2.6-0.3-4.5c-1.1-1.9-2.6-2.3-3.8-1.6 C287.4,128.8,287,130.3,288.2,132.2z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.5,132.2l2.3-0.6c0.1,0.3,0.8,3.3,0.8,4.4c0,0.3-0.6,0.6-1.2,0.6c-0.6-0.1-1-0.3-1.1-0.7 C289.2,135.3,288.8,133.3,288.5,132.2z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M291.6,128.1c-0.1-0.1-0.1-0.1-0.2-0.2c0.1-0.2,0.1-0.3,0-0.5c-0.1-0.2-0.4-0.2-0.6-0.2c0-0.2,0-0.4-0.1-0.5 c-0.1-0.2-0.3-0.3-0.5-0.2c-0.2,0-0.3,0.1-0.4,0c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3,0.1-0.3,0.2c0,0.1,0,0.3,0,0.5 c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.2,0.5c-0.4,0.2-0.8,0.6-1.1,0.9c-0.2,0.2-0.3,0.5-0.3,0.8c0,0,0,0-0.1,0.1 c-0.1,0-0.1,0-0.2,0.1c-0.3,0.1-0.4,0.4-0.5,0.7c0,0.3,0.1,0.6,0.3,0.8c0.1,0.1,0.2,0.3,0.2,0.4c0,0.1,0,0.1,0,0.2 c0,0.2,0,0.4,0.1,0.6s0.3,0.3,0.5,0.2c0.1,0,0.1,0,0.2-0.1c0.1-0.1,0.2-0.1,0.4-0.2c0.3-0.1,0.7-0.3,0.9-0.9c0.4-1.1,0.5-0.2,2-1.1 C292.4,129.3,291.6,128.1,291.6,128.1z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.6,133.2c0.3,0.4,1,0.8,1.4,0.6c0.3-0.2,0.2-0.6-0.1-1c-0.3-0.4-0.8-0.7-1.1-0.5 C287.5,132.4,287.4,132.8,287.6,133.2z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M285.9,142.3c0-0.3,0.3-4.7,1.2-5.7c1-1,2.4-1.3,3.2,0c0.8,1.3,0.5,5,0.9,7.9c0.4,2.9,1,5.6,1,5.6 s-4.3,2.4-4.5,1.8C287.4,150.7,286.4,146.3,285.9,142.3z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M282.9,159.2c-0.4,0-0.7,0.3-1.1,0.3c1.3-9,0.4-13.6,5.4-21.7c0.8-1.2,1.7-1.3,2.5-0.4c1,1,0.6,1.3-0.2,2.6 C284,148.2,285.6,150.4,282.9,159.2z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M287.9,128.3l-0.9,4.1c0,0-1.8-0.8-1.8-2.3C285.2,128.6,287.1,128.1,287.9,128.3z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M287.5,130.1c0,0,0-3,1.5-5.2c1.5-2.2,3.2,0.5,2.4,3.1C290.5,130.5,287.5,130.1,287.5,130.1z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M256.4,118.8c-0.1-0.1-0.3-0.1-0.5,0c-0.2,0.1-0.2,0.2-0.2,0.4v8.6c-0.5-0.1-1.2,0-1.8,0.3 c-1,0.6-1.5,1.6-1.1,2.3c0.4,0.7,1.6,0.9,2.6,0.3c0.8-0.5,1.3-1.3,1.2-1.9c0,0,0-0.1,0-0.1v-8.5c0.9,0.8,2.3,2.3,1.5,3.5 c-0.1,0.2-0.1,0.5,0.1,0.7c0.2,0.1,0.5,0.1,0.7-0.1C260.5,121.7,256.5,118.9,256.4,118.8z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M245.8,127.3h-9.4h-1.5v3.1v10.3c-0.7-0.2-1.7-0.1-2.7,0.4c-1.7,0.8-2.7,2.3-2.1,3.4c0.5,1.1,2.3,1.4,4,0.6 c1.4-0.6,2.3-1.9,2.3-2.9h0.1v-11.8h9.4v10.3c-0.7-0.2-1.7,0-2.6,0.4c-1.7,0.8-2.7,2.3-2.1,3.4c0.5,1.1,2.3,1.4,4,0.6 c1.4-0.6,2.3-1.9,2.3-2.9v-11.8v-3.1H245.8z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M247.6,157.1V152h17.8v5.6"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M277.3,155.5h-41.2v14.6h41.2V155.5z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M248.2,163.8c0.6-2.5-1-4.9-3.4-5.5c-2.5-0.6-4.9,1-5.5,3.4c-0.6,2.5,1,5,3.4,5.5 C245.1,167.8,247.6,166.3,248.2,163.8z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M273,166.1c1.8-1.8,1.8-4.7,0-6.5c-1.8-1.8-4.7-1.8-6.5,0c-1.8,1.8-1.8,4.7,0,6.5 C268.3,167.9,271.2,167.9,273,166.1z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M263.2,157.1h-13.1v8.3h13.1V157.1z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M252.2,166.6h-2.1v2.1h2.1V166.6z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M255,166.6h-2.1v2.1h2.1V166.6z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M257.7,166.6h-2.1v2.1h2.1V166.6z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M260.5,166.6h-2.1v2.1h2.1V166.6z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M263.2,166.6h-2.1v2.1h2.1V166.6z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M260.5,158.2h-7.6v4.3h7.6V158.2z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M55,113.3l-18,3l1.9,11.5l18-3L55,113.3z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M50.7,122.7c1-2.1,0.1-4.6-2-5.5c-2.1-1-4.6-0.1-5.5,2c-1,2.1-0.1,4.6,2,5.5C47.3,125.6,49.8,124.8,50.7,122.7 z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M43.8,121.5c-0.3-1.8,0.9-3.4,2.6-3.7s3.4,0.9,3.7,2.6c0.3,1.8-0.9,3.4-2.6,3.7 C45.7,124.4,44.1,123.2,43.8,121.5z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M42,116.5l-2.9,0.5l0.2,1l2.9-0.5L42,116.5z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M52.8,112.5l-1.8,0.3l0.2,1l1.8-0.3L52.8,112.5z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.8,121.5c0.5,0,1-0.4,1-1s-0.4-1-1-1c-0.5,0-1,0.4-1,1S45.3,121.5,45.8,121.5z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.7,187.2c0,0,0.1,0,0.1,0c0.4-0.1,0.7-0.5,0.6-0.9l-1.1-5.2c-0.1-0.4-0.5-0.7-0.9-0.6 c-0.4,0.1-0.7,0.5-0.6,0.9l1.1,5.2C70,187,70.3,187.2,70.7,187.2z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M71.6,186.2c0,0,0.4,1.9,0,2c-0.4,0.1-7,0.2-7-0.1c-0.1-1,5.2-2,5.8-1.9C70.8,186.4,71.5,186,71.6,186.2z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70,144.2c0,0-2,3.3-1.6,4.2s2.5-2,2.5-4.3L70,144.2z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.5,144.4c0.6,0.1,1.2,0.2,1.8,0.4c2.2-9.2,0.2-14.6-7.6-19.6c-1.2-0.8-1.6-0.4-2.1,0.6c-0.2,0-0.2,0,0,0 c-0.5,1.1-0.4,1.4,0.8,2.2C70.3,133,70.1,135,69.5,144.4z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.9,187.2c0,0,0.1,0,0.1,0c0.4-0.1,0.7-0.5,0.6-0.9l-1.1-5.2c-0.1-0.4-0.5-0.7-0.9-0.6 c-0.4,0.1-0.7,0.5-0.6,0.9l1.1,5.2C57.2,187,57.5,187.2,57.9,187.2z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M56.2,184.2c0.8,0,1.6-0.1,2.3-0.2c-2.3-12.5-4.1-29.2,2.1-40.9c-1.9-0.9-3.8-1.8-5.7-2.7 C50.4,150.5,54.3,173.5,56.2,184.2z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M69.1,183.8c0.8-0.2,1.5-0.5,2.3-0.8c-5.8-11.4-10.1-29.4-9.1-42.3c-2.1-0.1-4.3-0.2-6.4-0.2 C56.8,153.5,64.1,172.1,69.1,183.8z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M58.7,186.2c0,0,0.4,1.9,0,2s-7,0.2-7-0.1c-0.1-1,5.2-2,5.8-1.9C58,186.4,58.7,186,58.7,186.2z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M62.6,144.4c-1-0.4-2.5-0.8-5-0.9c-1.8-0.1-3.1,0-4.2,0.1c4.5-9.6,5.3-14.4,4.8-17.1c-0.2-1.3,0.3-2.7,1.4-3.5 l0.4-0.3c2-1.5,4.8-0.4,5.3,2c0.2,0.8,0.3,1.8,0.3,2.8C66,132.4,65.3,137.8,62.6,144.4z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.5,118.5c-0.8,2.1-3,3.2-4.2,2.6c-1.3-0.5-1.2-2.4-0.3-4.5c0.8-2.1,2.3-2.7,3.5-2.2 C63.7,115,64.3,116.4,63.5,118.5z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.1,119.6c-0.2,0.5-0.9,0.9-1.3,0.8c-0.3-0.1-0.3-0.5-0.1-1c0.2-0.5,0.7-0.8,1-0.7 C64.1,118.8,64.3,119.1,64.1,119.6z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M64.3,117.3c0,0,0.1-1.5-0.7-2.4c-0.8-0.9-2.8-1.6-4.1,0c0,0-0.7,1.2,0.9,2c1.6,0.8,1.6-0.2,2.1,0.9 c0.5,1.1,1.5,0.7,1.5,1L64.3,117.3z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,118.6l-2.3-0.2c0,0.3-0.3,3.4-0.2,4.5c0.1,0.3,0.7,0.5,1.3,0.4c0.6-0.1,1-0.5,1-0.8 C62.8,121.7,63,119.7,63.1,118.6z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M62.5,119.4c-0.4-0.3-0.7,0.1-1.4,0.7c-0.7,0.6-2.2,0.8-2.7-1.1c-0.3-1.2-0.6,0.9-0.6,0.9 c0.1,1,0.4,1.6,1.2,1.9c1,0.4,2.5,0.1,3.6-1C62.8,120.2,62.8,119.5,62.5,119.4z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M58.3,118.9C58.3,118.9,58.4,118.9,58.3,118.9c0.5,0.2,2.5,0.9,2.8,1.5c0.4,0.8-1-0.1-1.5-0.6 c-0.4-0.5-0.9-0.3-1.3-0.3C58,119.4,57.8,119,58.3,118.9z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.3,128.5c0,0-2.5-3.1-3.5-3.1c-1,0,1.1,3.2,3.3,4.1L49.3,128.5z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M64.6,125.7c-0.2-2.2-0.4-1.1-1.8-1.4c0,0-0.1,0-0.1,0c-1.2,0.7-1.4,0.3-1.2,2.1c1.7,12.6-6.7,6.8-12.1,1.8 c-0.5,0.4-1,0.8-1.5,1.2C55.3,137.2,66.3,140.5,64.6,125.7z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65,119.5l-7-3.2l1.2-1.1l0.1-0.1l0.4-0.6l0.6-1c0.2-0.4,0.8-0.5,1.2-0.4l3.7,1.7c0.4,0.2,0.7,0.7,0.5,1.1 l-0.3,1.1l-0.2,0.7l0,0.1L65,119.5z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M65.1,117.7l-5.8-2.6l0.4-0.6l5.7,2.5L65.1,117.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemories);
export default __webpack_public_path__ + "static/media/Memories.2f609db7492110d942113bc90e351c95.svg";
export { ForwardRef as ReactComponent };